/**
 * @generated SignedSource<<699f3cf61dfdd17236f94b158a9f8be2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChargeAddInput = {
  additionalInfo?: ReadonlyArray<ParamInput | null | undefined> | null | undefined;
  availablePaymentMethods?: ReadonlyArray<string | null | undefined> | null | undefined;
  clientMutationId?: string | null | undefined;
  comment?: string | null | undefined;
  correlationID?: string | null | undefined;
  customer?: CustomerInput | null | undefined;
  customerRegister?: boolean | null | undefined;
  customerRegisterFields?: ReadonlyArray<string | null | undefined> | null | undefined;
  enableCashbackExclusivePercentage?: boolean | null | undefined;
  enableCashbackPercentage?: boolean | null | undefined;
  expiresIn?: number | null | undefined;
  identifier?: string | null | undefined;
  redirectUrl?: string | null | undefined;
  shopperId?: string | null | undefined;
  splits?: ReadonlyArray<SplitPaymentInput | null | undefined> | null | undefined;
  type?: string | null | undefined;
  value?: number | null | undefined;
};
export type CustomerInput = {
  email?: string | null | undefined;
  name: string;
  phone?: string | null | undefined;
  taxID?: TaxIDInputType | null | undefined;
  taxIDValue?: string | null | undefined;
};
export type TaxIDInputType = {
  taxID: string;
  type: string;
};
export type ParamInput = {
  key: string;
  value?: string | null | undefined;
  values?: ReadonlyArray<string> | null | undefined;
};
export type SplitPaymentInput = {
  pixKey?: string | null | undefined;
  splitType?: string | null | undefined;
  value?: number | null | undefined;
};
export type ChargeAddMutation$variables = {
  input: ChargeAddInput;
};
export type ChargeAddMutation$data = {
  readonly ChargeAdd: {
    readonly charge: {
      readonly additionalInfo: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly brCode: string | null | undefined;
      readonly cashback: {
        readonly percentage: number | null | undefined;
        readonly status: string | null | undefined;
        readonly value: number | null | undefined;
      } | null | undefined;
      readonly cashbackExclusive: {
        readonly percentage: number | null | undefined;
        readonly status: string | null | undefined;
        readonly value: number | null | undefined;
      } | null | undefined;
      readonly cashbackExclusiveScheduled: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly value: number | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly comment: string | null | undefined;
      readonly company: {
        readonly logo: {
          readonly url: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly nameFriendly: string | null | undefined;
        readonly projectType: string | null | undefined;
        readonly taxID: {
          readonly taxID: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly correlationID: string | null | undefined;
      readonly createdAt: string | null | undefined;
      readonly customer: {
        readonly email: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly phone: string | null | undefined;
      } | null | undefined;
      readonly decodedBrCode: {
        readonly finalValue: number | null | undefined;
        readonly fines: number | null | undefined;
        readonly interests: number | null | undefined;
      } | null | undefined;
      readonly discount: number | null | undefined;
      readonly expiration: number | null | undefined;
      readonly expiresDate: string | null | undefined;
      readonly id: string;
      readonly identifier: string | null | undefined;
      readonly interestsSettings: {
        readonly active: boolean | null | undefined;
        readonly daysAfterDueDate: number | null | undefined;
        readonly fines: {
          readonly type: string | null | undefined;
          readonly value: number | null | undefined;
        } | null | undefined;
        readonly interests: {
          readonly modality: string | null | undefined;
          readonly type: string | null | undefined;
          readonly value: number | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly isRemoved: boolean | null | undefined;
      readonly payerIsCustomer: boolean | null | undefined;
      readonly paymentLinkUrl: string | null | undefined;
      readonly paymentMethods: ReadonlyArray<{
        readonly brCode?: string | null | undefined;
        readonly identifier?: string | null | undefined;
        readonly method?: string;
        readonly pixLocation?: string | null | undefined;
        readonly valueWithDiscount?: number | null | undefined;
      } | null | undefined> | null | undefined;
      readonly qrCodeImage: string | null | undefined;
      readonly status: string | null | undefined;
      readonly value: number | null | undefined;
      readonly valuePaid: number | null | undefined;
      readonly valueWithDiscount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"Order_charge">;
    } | null | undefined;
    readonly error: string | null | undefined;
  } | null | undefined;
};
export type ChargeAddMutation = {
  response: ChargeAddMutation$data;
  variables: ChargeAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifier",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Parameter",
  "kind": "LinkedField",
  "name": "additionalInfo",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueWithDiscount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiration",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correlationID",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentage",
  "storageKey": null
},
v12 = [
  (v5/*: any*/),
  (v11/*: any*/),
  (v3/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameFriendly",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxID",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "TaxID",
  "kind": "LinkedField",
  "name": "taxID",
  "plural": false,
  "selections": [
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "fitIn",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": "url(fitIn:true)"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valuePaid",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRemoved",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qrCodeImage",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brCode",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payerIsCustomer",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentLinkUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresDate",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysAfterDueDate",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "InterestsType",
  "kind": "LinkedField",
  "name": "interests",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modality",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "FinesType",
  "kind": "LinkedField",
  "name": "fines",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interests",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fines",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalValue",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pixLocation",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cashbackFidelityBalance",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanyPreferencesCharge",
  "kind": "LinkedField",
  "name": "chargeSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ChargeExpiration",
      "kind": "LinkedField",
      "name": "expiration",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fakeValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "logo",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availablePaymentMethods",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "installmentNumber",
  "storageKey": null
},
v47 = {
  "alias": "installments",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 12
    }
  ],
  "concreteType": "PaymentSubscriptionInstallmentConnection",
  "kind": "LinkedField",
  "name": "paymentSubscriptionInstallments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentSubscriptionInstallmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentSubscriptionInstallment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v46/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dateGenerateCharge",
              "storageKey": null
            },
            (v20/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "paymentSubscriptionInstallments(first:12)"
},
v48 = [
  (v47/*: any*/),
  (v20/*: any*/)
],
v49 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v3/*: any*/),
    (v46/*: any*/),
    (v5/*: any*/)
  ],
  "type": "PaymentMethodCreditCard",
  "abstractKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v3/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authorizationUrl",
      "storageKey": null
    }
  ],
  "type": "PaymentMethodITP",
  "abstractKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boletoBarcode",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boletoDigitable",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "DecodedBrCode",
  "kind": "LinkedField",
  "name": "decodedBrCode",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rebate",
      "storageKey": null
    },
    (v25/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Charge",
  "kind": "LinkedField",
  "name": "chargeIntent",
  "plural": false,
  "selections": [
    (v20/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": "installment",
  "args": null,
  "concreteType": "PaymentSubscriptionInstallment",
  "kind": "LinkedField",
  "name": "paymentSubscriptionInstallment",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "TaxIDObscured",
  "kind": "LinkedField",
  "name": "taxIDObscured",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v57 = [
  (v56/*: any*/),
  (v20/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "receiver",
  "plural": false,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v59 = [
  (v11/*: any*/),
  (v5/*: any*/),
  (v3/*: any*/),
  (v20/*: any*/),
  (v58/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Cashback",
  "kind": "LinkedField",
  "name": "cashback",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Cashback",
  "kind": "LinkedField",
  "name": "cashbackExclusive",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v62 = {
  "alias": "subscription",
  "args": null,
  "concreteType": "PaymentSubscription",
  "kind": "LinkedField",
  "name": "paymentSubscription",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redirectUrl",
  "storageKey": null
},
v65 = {
  "alias": "transactions",
  "args": null,
  "concreteType": "PixTransactionConnection",
  "kind": "LinkedField",
  "name": "pixTransactions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PixTransactionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PixTransaction",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endToEndId",
              "storageKey": null
            },
            (v20/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "CashbackConnection",
  "kind": "LinkedField",
  "name": "redeemedCashbackExclusive",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CashbackEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Cashback",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v58/*: any*/),
            (v20/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = [
  (v5/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChargeAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChargeAddPayload",
        "kind": "LinkedField",
        "name": "ChargeAdd",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Charge",
            "kind": "LinkedField",
            "name": "charge",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Order_charge"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Cashback",
                "kind": "LinkedField",
                "name": "cashback",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "logo",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v14/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Cashback",
                "kind": "LinkedField",
                "name": "cashbackExclusive",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CashbackConnection",
                "kind": "LinkedField",
                "name": "cashbackExclusiveScheduled",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CashbackEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Cashback",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeSettingsInterests",
                "kind": "LinkedField",
                "name": "interestsSettings",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DecodedBrCode",
                "kind": "LinkedField",
                "name": "decodedBrCode",
                "plural": false,
                "selections": [
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "paymentMethods",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v24/*: any*/),
                      (v40/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "PaymentMethodPix",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChargeAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChargeAddPayload",
        "kind": "LinkedField",
        "name": "ChargeAdd",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Charge",
            "kind": "LinkedField",
            "name": "charge",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v3/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerRegister",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v20/*: any*/),
                  (v41/*: any*/),
                  (v29/*: any*/),
                  (v18/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFromTestAccount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentMethodSelected",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyPreferencesSupport",
                        "kind": "LinkedField",
                        "name": "support",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "website",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  (v20/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "features",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v33/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "paymentMethods",
                "plural": true,
                "selections": [
                  (v45/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v40/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "PaymentMethodPix",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaymentSubscriptionInstallment",
                            "kind": "LinkedField",
                            "name": "currentInstallment",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Charge",
                                "kind": "LinkedField",
                                "name": "charge",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v24/*: any*/),
                                  (v20/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Company",
                                    "kind": "LinkedField",
                                    "name": "company",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v43/*: any*/),
                                      (v16/*: any*/),
                                      (v18/*: any*/),
                                      (v20/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CompanyPreferences",
                                        "kind": "LinkedField",
                                        "name": "preferences",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "paymentMethods",
                                    "plural": true,
                                    "selections": [
                                      (v45/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v24/*: any*/),
                                          (v5/*: any*/),
                                          (v7/*: any*/),
                                          (v39/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "type": "PaymentMethodPix",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PaymentSubscription",
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": (v48/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PaymentMethodInstallments",
                                        "abstractKey": null
                                      },
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v39/*: any*/),
                                          (v3/*: any*/),
                                          (v51/*: any*/),
                                          (v52/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "type": "PaymentMethodBoleto",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Customer",
                                    "kind": "LinkedField",
                                    "name": "customer",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v20/*: any*/),
                                      (v41/*: any*/),
                                      (v29/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v33/*: any*/),
                                  (v44/*: any*/),
                                  (v13/*: any*/),
                                  (v25/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChargeSettingsInterests",
                                    "kind": "LinkedField",
                                    "name": "interestsSettings",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v62/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompanyBankAccount",
                                    "kind": "LinkedField",
                                    "name": "companyBankAccount",
                                    "plural": false,
                                    "selections": [
                                      (v63/*: any*/),
                                      (v18/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  (v9/*: any*/),
                                  (v64/*: any*/),
                                  (v21/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Customer",
                                    "kind": "LinkedField",
                                    "name": "payer",
                                    "plural": false,
                                    "selections": (v57/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v20/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PaymentMethodInstallments",
                    "abstractKey": null
                  },
                  (v49/*: any*/),
                  (v50/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v3/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentMethodBoletoDelinquency",
                        "kind": "LinkedField",
                        "name": "delinquency",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PaymentMethodBoleto",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v13/*: any*/),
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeSettingsInterests",
                "kind": "LinkedField",
                "name": "interestsSettings",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  (v31/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyBankAccount",
                "kind": "LinkedField",
                "name": "companyBankAccount",
                "plural": false,
                "selections": [
                  (v63/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "itpCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyPixKey",
                    "kind": "LinkedField",
                    "name": "pixKeyRecipient",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pixKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pixKeyType",
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v25/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v27/*: any*/),
              (v62/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "availablePaymentMethodsList",
                "plural": true,
                "selections": [
                  (v45/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentMethodAvailableInstallment",
                        "kind": "LinkedField",
                        "name": "installments",
                        "plural": true,
                        "selections": [
                          (v46/*: any*/),
                          (v5/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PaymentMethodAvailableInstallments",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardProcessingProvider",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentMethodAvailablePixCredit",
                "kind": "LinkedField",
                "name": "availablePaymentMethodsPixCredit",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodAvailablePixCreditOption",
                    "kind": "LinkedField",
                    "name": "options",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueInCash",
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "installmentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "installmentValueTotal",
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/),
              (v21/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "payer",
                "plural": false,
                "selections": [
                  (v56/*: any*/),
                  (v20/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerRegisterFields",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSubscriptionInstallment",
                "kind": "LinkedField",
                "name": "paymentSubscriptionInstallment",
                "plural": false,
                "selections": (v67/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isShopifyCharge",
                "storageKey": null
              },
              (v8/*: any*/),
              (v23/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CashbackConnection",
                "kind": "LinkedField",
                "name": "cashbackExclusiveScheduled",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CashbackEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Cashback",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v67/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5897cd81ec69c1861e0d1a3ab2cb075c",
    "id": null,
    "metadata": {},
    "name": "ChargeAddMutation",
    "operationKind": "mutation",
    "text": "mutation ChargeAddMutation(\n  $input: ChargeAddInput!\n) {\n  ChargeAdd(input: $input) {\n    error\n    charge {\n      ...Order_charge\n      status\n      identifier\n      additionalInfo {\n        key\n        value\n      }\n      value\n      valueWithDiscount\n      expiration\n      createdAt\n      correlationID\n      cashback {\n        value\n        percentage\n        id\n        status\n      }\n      comment\n      company {\n        name\n        nameFriendly\n        projectType\n        taxID {\n          taxID\n        }\n        logo {\n          url(fitIn: true)\n          id\n        }\n        id\n      }\n      id\n      valuePaid\n      isRemoved\n      qrCodeImage\n      brCode\n      discount\n      payerIsCustomer\n      paymentLinkUrl\n      customer {\n        id\n        name\n        email\n        phone\n      }\n      cashbackExclusive {\n        value\n        percentage\n        status\n        id\n      }\n      cashbackExclusiveScheduled {\n        edges {\n          node {\n            value\n            id\n          }\n        }\n      }\n      expiresDate\n      interestsSettings {\n        active\n        daysAfterDueDate\n        interests {\n          value\n          type\n          modality\n        }\n        fines {\n          value\n          type\n        }\n      }\n      decodedBrCode {\n        interests\n        fines\n        finalValue\n      }\n      paymentMethods {\n        __typename\n        ... on PaymentMethodPix {\n          method\n          brCode\n          pixLocation\n          valueWithDiscount\n          identifier\n        }\n      }\n    }\n  }\n}\n\nfragment ChargePDFDocument_charge on Charge {\n  value\n  brCode\n  company {\n    name\n    nameFriendly\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  customer {\n    name\n    taxID {\n      taxID\n    }\n    id\n  }\n  expiresDate\n  createdAt\n  comment\n  identifier\n  ...useChargePaymentMethod_charge\n}\n\nfragment ChargePrintPDF_charge on Charge {\n  status\n  ...ChargePDFDocument_charge\n}\n\nfragment ITPButton_charge on Charge {\n  availablePaymentMethods\n  customer {\n    id\n  }\n}\n\nfragment Order_charge on Charge {\n  id\n  status\n  ...Payment_charge\n}\n\nfragment PaymentActiveBarcode_charge on Charge {\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentActiveBoletoDelinquencyWarning_charge on Charge {\n  paymentMethods {\n    __typename\n    ... on PaymentMethodBoleto {\n      delinquency {\n        type\n        status\n      }\n    }\n  }\n}\n\nfragment PaymentActiveBoleto_charge on Charge {\n  ...PaymentLinkComment_charge\n  ...PaymentLinkActiveEarnDiscount_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkShareButton_charge\n  ...PaymentActiveBarcode_charge\n  ...useChargePaymentMethod_charge\n  ...PaymentMethodPaymentDeadline_charge\n  ...PaymentMethodTransactionDetails_charge\n  ...PaymentMethodBoletoValue_charge\n  ...PaymentActiveBoletoDelinquencyWarning_charge\n  ...PaymentLinkActiveQrCode_charge\n  ...ChargePrintPDF_charge\n}\n\nfragment PaymentActiveCob_charge on Charge {\n  id\n  ...PaymentLinkActiveRoot_charge\n}\n\nfragment PaymentActiveCreditCardFailed_charge on Charge {\n  id\n  brCode\n  identifier\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  ...PaymentLinkComment_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkTransactionDetails_charge\n}\n\nfragment PaymentActiveCreditCardValue_charge on Charge {\n  company {\n    ...PaymentLinkActiveValue_company\n    id\n  }\n  value\n  valueWithDiscount\n}\n\nfragment PaymentActiveCreditCard_charge on Charge {\n  id\n  brCode\n  identifier\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  valueWithDiscount\n  ...PaymentLinkComment_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkTransactionDetails_charge\n}\n\nfragment PaymentActiveCustomerPixCreditCard_charge on Charge {\n  customer {\n    name\n    id\n  }\n  value\n  valueWithDiscount\n  type\n}\n\nfragment PaymentActiveCustomer_charge on Charge {\n  customer {\n    name\n    id\n  }\n  type\n  ...PaymentActiveCustomerPixCreditCard_charge\n}\n\nfragment PaymentActiveITPBanksList_charge on Charge {\n  companyBankAccount {\n    itpCode\n    id\n  }\n}\n\nfragment PaymentActiveITPBanks_charge on Charge {\n  id\n  ...PaymentActiveITPBanksList_charge\n}\n\nfragment PaymentActiveITPDetails_charge on Charge {\n  identifier\n  companyBankAccount {\n    pixKeyRecipient {\n      pixKey\n      pixKeyType\n      id\n    }\n    id\n  }\n}\n\nfragment PaymentActiveITPValue_charge on Charge {\n  value\n  valueWithDiscount\n  company {\n    ...PaymentLinkActiveValue_company\n    id\n  }\n}\n\nfragment PaymentActiveITP_charge on Charge {\n  ...PaymentActiveITPValue_charge\n  ...PaymentLinkComment_charge\n  ...PaymentLinkActiveEarnDiscount_charge\n  ...PaymentLinkActiveEarnCashback_charge\n  ...PaymentLinkActiveCashbackFidelityBalance_charge\n  ...PaymentLinkActiveEarnCashbackFidelity_charge\n  ...ITPButton_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentActiveITPDetails_charge\n  ...PaymentLinkAdditionalInfo_charge\n}\n\nfragment PaymentActiveInstallmentCompleted_charge on Charge {\n  ...PaymentCompleted_charge\n}\n\nfragment PaymentActiveInstallmentExpired_charge on Charge {\n  ...PaymentExpired_charge\n}\n\nfragment PaymentActiveInstallmentScheduled_charge on Charge {\n  id\n  brCode\n  identifier\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  valueWithDiscount\n  ...PaymentLinkComment_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkTransactionDetails_charge\n}\n\nfragment PaymentActiveInstallment_charge on Charge {\n  id\n  paymentMethods {\n    __typename\n    ... on PaymentMethodInstallments {\n      method\n      subscription {\n        currentInstallment {\n          status\n          charge {\n            status\n            brCode\n            ...PaymentActiveCob_charge\n            ...PaymentActiveInstallmentCompleted_charge\n            ...PaymentActiveInstallmentExpired_charge\n            ...PaymentActiveInstallmentScheduled_charge\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment PaymentActiveMethodInstallment_charge on Charge {\n  valueWithDiscount\n  availablePaymentMethods\n  availablePaymentMethodsList {\n    __typename\n    ... on PaymentMethodAvailableInstallments {\n      installments {\n        installmentNumber\n        value\n        discount\n      }\n    }\n  }\n}\n\nfragment PaymentActivePixCobValue_charge on Charge {\n  id\n  value\n  valueWithDiscount\n  company {\n    ...PaymentLinkActiveValue_company\n    id\n  }\n  decodedBrCode {\n    interests\n    fines\n    finalValue\n  }\n  chargeIntent {\n    id\n  }\n  installment: paymentSubscriptionInstallment {\n    installmentNumber\n    id\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      value\n      valueWithDiscount\n    }\n  }\n  ...PaymentLinkValueFirstInstallment_charge\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentActivePixCreditCard_charge on Charge {\n  id\n  brCode\n  identifier\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  ...useChargePaymentMethod_charge\n  ...PaymentActiveCreditCard_charge\n  ...PaymentActiveCob_charge\n}\n\nfragment PaymentActiveWaitingCustomerFillData_charge on Charge {\n  id\n  ...PaymentActivePixCobValue_charge\n  ...PaymentLinkTransactionDetails_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentLinkComment_charge\n  ...PaymentLinkActiveEarnCashback_charge\n  ...PaymentLinkActiveCashbackFidelityBalance_charge\n  ...PaymentLinkActiveEarnCashbackFidelity_charge\n  paymentMethodSelected\n}\n\nfragment PaymentActiveWaitingPaymentMethodCreditCard_charge on Charge {\n  id\n  status\n  identifier\n  availablePaymentMethods\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  customer {\n    name\n    taxID {\n      taxID\n    }\n    id\n  }\n  valueWithDiscount\n  ...PaymentLinkComment_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentActiveCreditCardValue_charge\n  ...PaymentMethodPaymentDeadline_charge\n  ...PaymentMethodTransactionDetails_charge\n  ...PaymentMethodCreditCardValue_charge\n  cardProcessingProvider\n}\n\nfragment PaymentActiveWaitingPaymentMethodPixCreditCard_charge on Charge {\n  id\n  status\n  identifier\n  availablePaymentMethods\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  customer {\n    name\n    taxID {\n      taxID\n    }\n    id\n  }\n  availablePaymentMethodsPixCredit {\n    options {\n      valueInCash\n      installmentNumber\n      installmentValue\n      installmentValueTotal\n    }\n  }\n  valueWithDiscount\n  ...PaymentPixCreditOptions_charge\n  ...PaymentActiveCreditCard_charge\n  ...PaymentLinkComment_charge\n  ...PaymentActiveCustomer_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentLinkTransactionDetails_charge\n}\n\nfragment PaymentActiveWaitingPaymentMethodRoot_charge on Charge {\n  id\n  availablePaymentMethods\n  ...PaymentActiveWaitingPaymentMethod_charge\n  ...PaymentActiveWaitingPaymentMethodCreditCard_charge\n  ...PaymentActiveWaitingPaymentMethodPixCreditCard_charge\n}\n\nfragment PaymentActiveWaitingPaymentMethod_charge on Charge {\n  id\n  status\n  identifier\n  availablePaymentMethods\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  ...PaymentLinkComment_charge\n  ...PaymentActiveCustomer_charge\n  ...PaymentActiveMethodInstallment_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentLinkTransactionDetails_charge\n}\n\nfragment PaymentActive_charge on Charge {\n  id\n  status\n  ...useChargePaymentMethod_charge\n  ...PaymentActivePixCreditCard_charge\n  ...PaymentActiveInstallment_charge\n  ...PaymentActiveCob_charge\n  ...PaymentActiveCreditCard_charge\n  ...PaymentActiveCreditCardFailed_charge\n  ...PaymentActiveITPBanks_charge\n  ...PaymentActiveITP_charge\n}\n\nfragment PaymentCharge_charge on Charge {\n  id\n  status\n  isRemoved\n  customerRegister\n  customer {\n    name\n    id\n  }\n  isFromTestAccount\n  paymentMethodSelected\n  company {\n    projectType\n    ...PaymentCompanySupport_company\n    ...PaymentCompanyLogo_company\n    id\n  }\n  ...PaymentActive_charge\n  ...PaymentActiveWaitingPaymentMethodRoot_charge\n  ...PaymentDeleted_charge\n  ...PaymentCompleted_charge\n  ...PaymentExpired_charge\n  ...PaymentActiveWaitingCustomerFillData_charge\n  ...PaymentTestAccountBanner_charge\n  ...PaymentMethodCreditCardSelected_charge\n  ...PaymentMethodBoletoSelected_charge\n  ...PaymentDispute_charge\n  ...PaymentMethodSelectedPending_charge\n  ...PaymentMethodPixSelected_charge\n  ...PaymentShopify_charge\n}\n\nfragment PaymentCompanyLogo_company on Company {\n  projectType\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n\nfragment PaymentCompanySupportEmail_company on Company {\n  preferences {\n    support {\n      email\n    }\n  }\n}\n\nfragment PaymentCompanySupportPhone_company on Company {\n  preferences {\n    support {\n      phone\n    }\n  }\n}\n\nfragment PaymentCompanySupportWebsite_company on Company {\n  preferences {\n    support {\n      website\n    }\n  }\n}\n\nfragment PaymentCompanySupportWhatsApp_company on Company {\n  preferences {\n    support {\n      phone\n    }\n  }\n}\n\nfragment PaymentCompanySupport_company on Company {\n  preferences {\n    support {\n      email\n      phone\n      website\n    }\n  }\n  ...PaymentCompanySupportEmail_company\n  ...PaymentCompanySupportPhone_company\n  ...PaymentCompanySupportWebsite_company\n  ...PaymentCompanySupportWhatsApp_company\n}\n\nfragment PaymentCompleted_charge on Charge {\n  ...PaymentLinkCompleted_charge\n}\n\nfragment PaymentDeleted_charge on Charge {\n  identifier\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  ...PaymentLinkDeletedValue_charge\n  ...PaymentLinkAdditionalInfo_charge\n}\n\nfragment PaymentDispute_charge on Charge {\n  id\n  value\n  status\n  transactions: pixTransactions {\n    edges {\n      node {\n        endToEndId\n        id\n      }\n    }\n  }\n  payer {\n    email\n    phone\n    taxID {\n      taxID\n    }\n    id\n  }\n  company {\n    taxID {\n      taxID\n    }\n    id\n  }\n}\n\nfragment PaymentExpired_charge on Charge {\n  identifier\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  ...PaymentLinkExpiredValue_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentMethodTransactionDetails_charge\n}\n\nfragment PaymentInstallmentPlan_charge on Charge {\n  chargeIntent {\n    id\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodInstallments {\n      method\n    }\n  }\n  ...PaymentInstallments_charge\n}\n\nfragment PaymentInstallmentRow_paymentSubscriptionInstallment on PaymentSubscriptionInstallment {\n  status\n  installmentNumber\n  value\n  dateGenerateCharge\n}\n\nfragment PaymentInstallments_charge on Charge {\n  subscription: paymentSubscription {\n    installments: paymentSubscriptionInstallments(first: 12) {\n      edges {\n        node {\n          ...PaymentInstallmentRow_paymentSubscriptionInstallment\n          id\n        }\n      }\n    }\n    id\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodInstallments {\n      method\n      subscription {\n        installments: paymentSubscriptionInstallments(first: 12) {\n          edges {\n            node {\n              ...PaymentInstallmentRow_paymentSubscriptionInstallment\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment PaymentLinkActiveCashbackFidelityBalance_charge on Charge {\n  customer {\n    cashbackFidelityBalance\n    id\n  }\n}\n\nfragment PaymentLinkActiveEarnCashbackFidelity_charge on Charge {\n  cashbackExclusive {\n    percentage\n    value\n    status\n    id\n  }\n}\n\nfragment PaymentLinkActiveEarnCashback_charge on Charge {\n  cashback {\n    percentage\n    value\n    status\n    id\n  }\n}\n\nfragment PaymentLinkActiveEarnDiscount_charge on Charge {\n  discount\n}\n\nfragment PaymentLinkActiveInterestsSettings_charge on Charge {\n  value\n  interestsSettings {\n    active\n  }\n  decodedBrCode {\n    interests\n    fines\n    rebate\n    discount\n    finalValue\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      value\n    }\n  }\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentLinkActivePixCreditCard_charge on Charge {\n  value\n  valueWithDiscount\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentLinkActiveQrCode_charge on Charge {\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      method\n      brCode\n    }\n  }\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentLinkActiveRoot_charge on Charge {\n  id\n  brCode\n  identifier\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      brCode\n    }\n  }\n  ...PaymentActivePixCobValue_charge\n  ...PaymentLinkComment_charge\n  ...PaymentLinkActiveEarnDiscount_charge\n  ...PaymentLinkActiveEarnCashback_charge\n  ...PaymentLinkActiveCashbackFidelityBalance_charge\n  ...PaymentLinkActiveEarnCashbackFidelity_charge\n  ...PaymentLinkActiveQrCode_charge\n  ...PaymentLinkShareButton_charge\n  ...PaymentLinkActiveInterestsSettings_charge\n  ...PaymentInstallmentPlan_charge\n  ...PaymentLinkPaymentTerm_charge\n  ...PaymentLinkTransactionDetails_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...useChargePaymentMethod_charge\n  ...PaymentLinkActivePixCreditCard_charge\n  ...ITPButton_charge\n  ...ChargePrintPDF_charge\n}\n\nfragment PaymentLinkActiveValue_company on Company {\n  nameFriendly\n}\n\nfragment PaymentLinkAdditionalInfo_charge on Charge {\n  additionalInfo {\n    key\n    value\n  }\n}\n\nfragment PaymentLinkComment_charge on Charge {\n  comment\n}\n\nfragment PaymentLinkCompletedPaymentMethods_charge on Charge {\n  id\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentLinkCompletedPixCreditCard_charge on Charge {\n  value\n  valueWithDiscount\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentLinkCompletedQrCodeValue_charge on Charge {\n  id\n  discount\n  value\n  valuePaid\n  valueWithDiscount\n  chargeIntent {\n    id\n  }\n  type\n}\n\nfragment PaymentLinkCompletedRedirect_charge on Charge {\n  redirectUrl\n  status\n}\n\nfragment PaymentLinkCompletedRewards_charge on Charge {\n  cashback {\n    value\n    status\n    receiver {\n      taxIDObscured {\n        taxID\n        type\n      }\n      id\n    }\n    id\n  }\n  cashbackExclusive {\n    value\n    status\n    receiver {\n      taxIDObscured {\n        taxID\n        type\n      }\n      id\n    }\n    id\n  }\n  redeemedCashbackExclusive {\n    edges {\n      node {\n        value\n        receiver {\n          taxIDObscured {\n            taxID\n            type\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  payer {\n    taxIDObscured {\n      taxID\n      type\n    }\n    id\n  }\n}\n\nfragment PaymentLinkCompletedTransaction_charge on Charge {\n  transactions: pixTransactions {\n    edges {\n      node {\n        endToEndId\n        id\n      }\n    }\n  }\n}\n\nfragment PaymentLinkCompleted_charge on Charge {\n  id\n  discount\n  identifier\n  redirectUrl\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  ...PaymentLinkCompletedQrCodeValue_charge\n  ...PaymentInstallmentPlan_charge\n  ...PaymentLinkCompletedTransaction_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkCompletedRewards_charge\n  ...PaymentLinkTransactionDetails_charge\n  ...PaymentLinkCompletedPixCreditCard_charge\n  ...PaymentLinkCompletedPaymentMethods_charge\n  ...PaymentLinkCompletedRedirect_charge\n}\n\nfragment PaymentLinkDeletedValue_charge on Charge {\n  id\n  value\n  valueWithDiscount\n}\n\nfragment PaymentLinkExpiredValue_charge on Charge {\n  id\n  discount\n  value\n  valueWithDiscount\n}\n\nfragment PaymentLinkPaymentTerm_charge on Charge {\n  status\n  expiresDate\n  company {\n    id\n    preferences {\n      chargeSettings {\n        expiration {\n          type\n          fakeValue\n        }\n      }\n    }\n  }\n  interestsSettings {\n    daysAfterDueDate\n  }\n}\n\nfragment PaymentLinkShareButton_charge on Charge {\n  company {\n    nameFriendly\n    projectType\n    id\n  }\n  paymentLinkUrl\n  cashback {\n    value\n    id\n  }\n  customer {\n    phone\n    id\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      value\n      valueWithDiscount\n    }\n  }\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentLinkTransactionDetails_charge on Charge {\n  identifier\n  company {\n    nameFriendly\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  companyBankAccount {\n    officialName\n    taxID {\n      taxID\n    }\n    id\n  }\n}\n\nfragment PaymentLinkValueFirstInstallment_charge on Charge {\n  id\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      value\n      valueWithDiscount\n    }\n  }\n  customer {\n    name\n    id\n  }\n  company {\n    nameFriendly\n    id\n  }\n}\n\nfragment PaymentMethodBoletoPixValue_charge on Charge {\n  company {\n    nameFriendly\n    id\n  }\n  value\n}\n\nfragment PaymentMethodBoletoSelected_charge on Charge {\n  id\n  status\n  customer {\n    id\n  }\n  ...PaymentActiveBoleto_charge\n  ...PaymentCompleted_charge\n  ...PaymentMethodSelectedCustomerRegister_charge\n}\n\nfragment PaymentMethodBoletoValue_charge on Charge {\n  company {\n    nameFriendly\n    id\n  }\n  value\n  ...useChargePaymentMethod_charge\n  ...PaymentMethodBoletoPixValue_charge\n}\n\nfragment PaymentMethodCreditCardConfirmStep_charge on Charge {\n  id\n  status\n  identifier\n  availablePaymentMethods\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  customer {\n    name\n    taxID {\n      taxID\n    }\n    id\n  }\n  valueWithDiscount\n  cardProcessingProvider\n}\n\nfragment PaymentMethodCreditCardCustomerRegisterStep_charge on Charge {\n  id\n}\n\nfragment PaymentMethodCreditCardSelectedProcessing_charge on Charge {\n  id\n  brCode\n  identifier\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  valueWithDiscount\n  ...PaymentLinkComment_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkTransactionDetails_charge\n}\n\nfragment PaymentMethodCreditCardSelected_charge on Charge {\n  id\n  status\n  company {\n    features\n    id\n  }\n  customer {\n    id\n  }\n  ...PaymentCompleted_charge\n  ...PaymentActiveWaitingPaymentMethodCreditCard_charge\n  ...PaymentMethodCreditCardSelectedProcessing_charge\n  ...PaymentMethodSelectedCustomerRegister_charge\n  ...useChargePaymentMethod_charge\n  ...PaymentMethodCreditCardSteps_charge\n}\n\nfragment PaymentMethodCreditCardSteps_charge on Charge {\n  id\n  status\n  customer {\n    id\n    name\n    taxID {\n      taxID\n    }\n    email\n    phone\n  }\n  ...PaymentMethodCreditCardValue_charge\n  ...PaymentMethodTransactionDetails_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentMethodPaymentDeadline_charge\n  ...PaymentMethodCreditCardCustomerRegisterStep_charge\n  ...PaymentMethodCreditCardConfirmStep_charge\n  ...PaymentLinkComment_charge\n}\n\nfragment PaymentMethodCreditCardValue_charge on Charge {\n  value\n  company {\n    nameFriendly\n    id\n  }\n}\n\nfragment PaymentMethodPaymentDeadline_charge on Charge {\n  expiresDate\n  createdAt\n  company {\n    id\n    nameFriendly\n    preferences {\n      chargeSettings {\n        expiration {\n          type\n          fakeValue\n        }\n      }\n    }\n  }\n}\n\nfragment PaymentMethodPendingMessage_charge on Charge {\n  company {\n    nameFriendly\n    id\n  }\n  value\n}\n\nfragment PaymentMethodPixQrCode_charge on Charge {\n  ...useChargePaymentMethod_charge\n}\n\nfragment PaymentMethodPixSelected_charge on Charge {\n  id\n  brCode\n  identifier\n  customerRegister\n  customer {\n    id\n  }\n  company {\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n    projectType\n    taxID {\n      taxID\n    }\n    id\n  }\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      brCode\n    }\n  }\n  ...PaymentMethodPixValue_charge\n  ...PaymentLinkComment_charge\n  ...PaymentLinkActiveEarnDiscount_charge\n  ...PaymentLinkActiveEarnCashback_charge\n  ...PaymentLinkActiveCashbackFidelityBalance_charge\n  ...PaymentLinkActiveEarnCashbackFidelity_charge\n  ...PaymentLinkShareButton_charge\n  ...PaymentLinkActiveInterestsSettings_charge\n  ...PaymentLinkAdditionalInfo_charge\n  ...useChargePaymentMethod_charge\n  ...PaymentMethodPixQrCode_charge\n  ...PaymentMethodTransactionDetails_charge\n  ...PaymentMethodPaymentDeadline_charge\n  ...PaymentMethodSelectedCustomerRegister_charge\n  ...ChargePrintPDF_charge\n}\n\nfragment PaymentMethodPixValue_charge on Charge {\n  company {\n    nameFriendly\n    id\n  }\n  value\n  paymentSubscriptionInstallment {\n    value\n    id\n  }\n}\n\nfragment PaymentMethodSelectedCustomerRegisterFormFields_charge on Charge {\n  id\n  paymentMethodSelected\n  customerRegisterFields\n}\n\nfragment PaymentMethodSelectedCustomerRegisterForm_charge on Charge {\n  id\n  paymentMethodSelected\n}\n\nfragment PaymentMethodSelectedCustomerRegisterValue_charge on Charge {\n  value\n  paymentMethodSelected\n  company {\n    nameFriendly\n    id\n  }\n  ...PaymentMethodPixValue_charge\n  ...PaymentMethodBoletoValue_charge\n  ...PaymentMethodCreditCardValue_charge\n}\n\nfragment PaymentMethodSelectedCustomerRegister_charge on Charge {\n  id\n  customerRegisterFields\n  ...PaymentLinkAdditionalInfo_charge\n  ...PaymentLinkComment_charge\n  ...PaymentMethodPaymentDeadline_charge\n  ...PaymentMethodTransactionDetails_charge\n  ...PaymentLinkActiveEarnCashback_charge\n  ...PaymentLinkActiveCashbackFidelityBalance_charge\n  ...PaymentLinkActiveEarnCashbackFidelity_charge\n  ...PaymentMethodSelectedCustomerRegisterValue_charge\n  ...PaymentMethodSelectedCustomerRegisterForm_charge\n  ...PaymentMethodSelectedCustomerRegisterFormFields_charge\n}\n\nfragment PaymentMethodSelectedPending_charge on Charge {\n  id\n  availablePaymentMethods\n  ...PaymentMethodPendingMessage_charge\n  ...PaymentMethodTransactionDetails_charge\n  ...PaymentMethodPaymentDeadline_charge\n}\n\nfragment PaymentMethodTransactionDetails_charge on Charge {\n  identifier\n  correlationID\n  company {\n    nameFriendly\n    taxID {\n      taxID\n    }\n    id\n  }\n  companyBankAccount {\n    id\n    officialName\n    taxID {\n      taxID\n    }\n  }\n}\n\nfragment PaymentPixCreditOptions_charge on Charge {\n  valueWithDiscount\n  availablePaymentMethods\n  availablePaymentMethodsPixCredit {\n    options {\n      valueInCash\n      installmentNumber\n      installmentValue\n      discount\n    }\n  }\n}\n\nfragment PaymentProvider_charge on Charge {\n  status\n  redirectUrl\n  isShopifyCharge\n}\n\nfragment PaymentShopify_charge on Charge {\n  isShopifyCharge\n  status\n}\n\nfragment PaymentTestAccountBanner_charge on Charge {\n  id\n  isFromTestAccount\n}\n\nfragment Payment_charge on Charge {\n  ...PaymentCharge_charge\n  ...PaymentProvider_charge\n}\n\nfragment useChargePaymentMethod_charge on Charge {\n  type\n  availablePaymentMethods\n  paymentMethods {\n    __typename\n    ... on PaymentMethodPix {\n      method\n      status\n      brCode\n      value\n      valueWithDiscount\n    }\n    ... on PaymentMethodInstallments {\n      method\n    }\n    ... on PaymentMethodCreditCard {\n      method\n      status\n      installmentNumber\n      value\n    }\n    ... on PaymentMethodITP {\n      method\n      status\n      value\n      consentId\n      authorizationUrl\n    }\n    ... on PaymentMethodBoleto {\n      method\n      status\n      boletoBarcode\n      boletoDigitable\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a49b08344d8ad51b168c912f6a6ef920";

export default node;
